export interface CaptchaKeyConfig {
	key: string;
	apiKey: string;
	projectId: string;
}

/**
 * Retrieves the captcha key configuration from the environment variables.
 * @returns {CaptchaKeyConfig} The captcha key
 * @throws {Error} If the captcha configuration is not set.
 */
export function loadCaptchaKeyConfig(): CaptchaKeyConfig {
	const { RECAPTCHA_SITE_KEY, RECAPTCHA_API_KEY, RECAPTCHA_PROJECT_ID } =
		process.env;
	if (!RECAPTCHA_SITE_KEY || !RECAPTCHA_API_KEY || !RECAPTCHA_PROJECT_ID) {
		throw new Error(
			"RECAPTCHA_SITE_KEY, RECAPTCHA_API_KEY, or RECAPTCHA_PROJECT_ID config is not set."
		);
	}

	return {
		key: RECAPTCHA_SITE_KEY,
		apiKey: RECAPTCHA_API_KEY,
		projectId: RECAPTCHA_PROJECT_ID
	};
}
